material-checkboxes
  .checkboxes(class="{props.type} {props.mobile ? 'sp' : 'pc'}")
    template(each="{(materialMaster, index) in state.materialMasters}")
      label
        template(if="{props.type === 'in_modal'}")
          img(src="{checkboxOnIcon}" class="checkbox-icon { state.materials.includes(materialMaster.material) ? '' : 'hidden' }")
          img(src="{checkboxOffIcon}" class="checkbox-icon { state.materials.includes(materialMaster.material) ? 'hidden' : '' }")
        input(type="checkbox" onchange="{didChangeMaterial}" name="mt[{index}]" value="{materialMaster.material}"
              checked="{state.existMaterial.includes(materialMaster.material)}")
        img(src="{materialMaster.icon}" class="material-icon")
        | { materialMaster.text }
  style(type="scss").
    .checkboxes {
      display: flex;
      flex-wrap: wrap;
      label {
        input {
          margin-right: 7px;
        }
        img {
          margin-right: 7px;
        }
      }
      &.pc {
        label {
          a {
            font-size: 12px;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
      &.in_sidebar {
        margin-top: 10px;
        border-top: 2px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        label {
          border-top: 1px solid #e8e8e8;
          border-bottom: 2px solid #e8e8e8;
          padding: 12px 9px;
          display: flex;
          align-items: center;
          width: 50%;
          &:nth-child(odd) {
            border-right: 1px solid #e8e8e8;
          }
        }
        .pc label {
          cursor: pointer;
        }
        &.sp {
          border-bottom: 0;
          margin-top: 16px;
          border-top: 2px solid #e8e8e8;
          label {
            border-top: 0;
            font-size: 15px;
            &:nth-child(odd) {
              border-right-width: 2px;
            }
          }
        }
      }
      &.in_modal {
        row-gap: 11.25vw;
        label {
          width: 50%;
          color: #6c6c6c;
          font-size: 4.6875vw;
          font-weight: 700;
          display: flex;
          align-items: center;
          input {
            display: none;
          }
          .checkbox-icon {
            height: 6.40625vw;
            width: 6.40625vw;
            margin-right: 1.25vw;
            &.hidden {
              display: none;
            }
          }
          .material-icon {
            height: 5.9375vw;
            width: 5.9375vw;
            margin-right: 2.34375vw;
          }
        }
      }
    }
  script.
    import checkboxOnIcon from 'tags/smartsearch/checkbox_t.png'
    import checkboxOffIcon from 'tags/smartsearch/checkbox_f.png'
    import SmartsearchMaster from 'models/smartsearch-master.js'

    export default {
      checkboxOnIcon,
      checkboxOffIcon,
      onBeforeMount(props, state) {
        const masterData = new SmartsearchMaster()
        state.materialMasters = masterData.materialMasters
        state.materialValues = state.materialMasters.map(current => current.material)

        state.existMaterial = []
        state.materials = []
      },
      didChangeMaterial() {
        const materialElements = this.root.querySelectorAll('.checkboxes input')
        const materials = Array.prototype.map.call(materialElements, (c) => {
          return c.checked ? c.value : ''
        }).filter(material => material.length > 0)
        const materialQuery = materials.join(',')
        this.update({
          materialQuery,
          materials
        })
        this.props.onUpdate(materialQuery)
      },
      initializeByExistQuery() {
        const result = (new RegExp('[?&]'+encodeURIComponent('mt')+'=([^&]*)')).exec(location.search)
        if(!result) return

        const existMaterial = decodeURIComponent(result[1]).split(',')
        this.update({
          existMaterial,
          materials: existMaterial
        })
      },
      urlFromValueWithFormData(value) {
        const queryKey = 'mt'
        if (!this.props.formdata) return

        const formDataObj = Object.fromEntries(Array.from(this.props.formdata.entries()))

        const currentValues = (this.state.materialQuery || '').split(',')
        if (!currentValues.includes(value)) {
          const values = Array.from(this.state.materialValues).filter( v => (currentValues.includes(v) || value == v) )
          formDataObj[queryKey] = values.join(',')
        }
        const formDataArray = Array.from(Object.entries(formDataObj)).sort( (kv1, kv2) => {
          if (kv1 < kv2) { return -1 }
          else if (kv1 > kv2) { return 1 }
          else return 0
        })
        const url = '/watches/?' + formDataArray.filter( kv => !!kv[1] ).map( kv => kv[0] + '=' + kv[1] ).join('&')
        return url
      },
      onMounted(props, state) {
        this.initializeByExistQuery()
        this.update()
      },
    }
